export const TAB_LINK = 'Link';
export const CLIPBOARD = 'Copy to clipboard';
export const SUCCESS_CLIPBOARD = 'Have successfully copied to clipboard!';
